import React from "react";


const PricingProgressBar = ({
  currentAmount,
  targetAmount,
  currency = "₹",
}) => {
  const progressPercentage = Math.min(
    (currentAmount / targetAmount) * 100,
    100
  );

  // Total number of segments in the progress bar
  const totalSegments = 40;

  // Calculate how many segments should be filled
  const filledSegments = Math.round((progressPercentage / 100) * totalSegments);

  // Format numbers with Indian number system
  const formatIndianNumber = (num) => {
    return num.toLocaleString("en-IN");
  };

  return (
    <div className="w-full max-w-md">
      {/* Price Display */}
      <div className="mb-4">
        <span className="text-3xl font-bold text-gray-900">
          {currency}
          {formatIndianNumber(currentAmount)}
        </span>
        <span className="text-lg text-gray-500 ml-1">
          / {currency}
          {formatIndianNumber(targetAmount)}
        </span>
      </div>

      {/* Progress Bar */}
      <div className="flex gap-[4px] w-full">
        {Array.from({ length: totalSegments }, (_, index) => (
          <div
            key={index}
            className={`h-6 flex-1 ${
              index < filledSegments ? "bg-green-500" : "bg-gray-300"
            }`}
          />
        ))}
      </div>

      
    </div>
  );
};

export default PricingProgressBar;
